/**
 * Shared constants for Service Request lists, certificates, and permits.
 */

export const DEFAULT_PAGE_SIZE = 10;

export const SemenDoseStatus = {
    Active: "Active",
    Used: "Used",
};

export const EmbryoPermitStatus = {
    Active: "Active",
    Expired: "Expired",
};

export const CertificateStatus = {
    Active: "Active",
    Used: "Used",
    Expired: "Expired",
};

